var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmFam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".amfam-cls-1{fill:#fff;}.amfam-cls-2{fill:#878787;}.amfam-cls-3{fill:#003da6;}.amfam-cls-4{fill:#dd0031;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AmFam"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "amfam-cls-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "amfam-cls-2",
    d: "M15,1A14,14,0,1,1,1,15,14,14,0,0,1,15,1m0-1A15,15,0,1,0,30,15,15,15,0,0,0,15,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "amfam-cls-3",
    x: 6.85,
    y: 17.23,
    width: 17.15,
    height: 4.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "amfam-cls-4",
    points: "24 13.37 18.54 13.37 12.92 9.88 7.7 13.12 6 10.39 12.92 6.09 19.45 10.15 24 10.15 24 13.37"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmFam);
export default __webpack_public_path__ + "static/media/AmFam.0be386aa08b97a698ade00731b4a6dfb.svg";
export { ForwardRef as ReactComponent };